export default __webpack_public_path__ + "static/media/35t.f97c199b.jpg";